import { useEffect, useRef, useState } from "react";
import { useAuth, useSignIn } from "@clerk/react";
import { Loader2 } from "lucide-react";

// DEV only: consumes a one-time Clerk sign-in token of a synthetic test user (created in Impostazioni › Utenti di test).
export default function TestLogin() {
  const { isLoaded, isSignedIn } = useAuth();
  const { signIn } = useSignIn();
  const [err, setErr] = useState("");
  const done = useRef(false);
  const ticket = new URLSearchParams(window.location.search).get("ticket");
  useEffect(() => {
    if (!isLoaded || isSignedIn || done.current || !ticket) return;
    done.current = true;
    (async () => {
      const { error } = await signIn.ticket({ ticket });
      if (error) return setErr("Link di accesso già usato o scaduto: generane uno nuovo da Impostazioni › Utenti di test.");
      if (signIn.status !== "complete") return setErr("Accesso non completato");
      await signIn.finalize({ navigate: ({ decorateUrl }) => { window.location.assign(decorateUrl("/area")); } });
    })();
  }, [isLoaded, isSignedIn, ticket, signIn]);
  const box = "mx-auto mt-24 max-w-md rounded-xl border bg-white p-6 text-sm text-slate-700 shadow-sm";
  if (!ticket) return <div className={box} data-testid="test-login-missing">Link di accesso di test mancante.</div>;
  if (isLoaded && isSignedIn && !done.current) return <div className={box} data-testid="test-login-signed-in">Sei già collegato con un altro account. Apri questo link in una <b>finestra anonima/privata</b> (così resti collegato come amministratore qui).</div>;
  return <div className={box} data-testid="test-login">{err ? <p className="text-red-600" data-testid="test-login-error">{err}</p> : <p className="flex items-center gap-2"><Loader2 size={15} className="animate-spin" />Accesso come utente di test…</p>}</div>;
}
